import { Pipe, PipeTransform } from '@angular/core';
import { ClientDocumentStatus } from 'src/app/shared/api-services/cms/models/client-document.model';

@Pipe({
  name: 'clientDocumentStatusClass'
})
export class ClientDocumentStatusClassPipe implements PipeTransform {
  transform(status: ClientDocumentStatus | null | undefined): string {
    switch (status) {
      case ClientDocumentStatus.APPROVED: return 'anq-status-success';
      case ClientDocumentStatus.REJECTED: return 'anq-status-danger';
      case ClientDocumentStatus.PENDING: return 'anq-status-warning';
      default: return 'anq-status-neutral';
    }
  }
}

@Pipe({
  name: 'clientDocumentStatusLabel'
})
export class ClientDocumentStatusLabelPipe implements PipeTransform {
  transform(status: ClientDocumentStatus | null | undefined): string {
    switch (status) {
      case ClientDocumentStatus.APPROVED: return 'Approved';
      case ClientDocumentStatus.REJECTED: return 'Rejected';
      case ClientDocumentStatus.PENDING: return 'Pending';
      default: return 'Not Uploaded';
    }
  }
}
